import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      d="M2.5 8C2.5 4.96499 4.97482 2.5 8.03379 2.5C10.1843 2.5 12.0485 3.71928 12.9644 5.5H10.8667C10.5905 5.5 10.3667 5.72386 10.3667 6C10.3667 6.27614 10.5905 6.5 10.8667 6.5H13.8C13.9045 6.5 14.0097 6.48361 14.1103 6.45026C14.2109 6.41694 14.3084 6.36614 14.3952 6.29671C14.4821 6.22717 14.5585 6.13862 14.6136 6.03235C14.6689 5.92544 14.7 5.8053 14.7 5.68V2.86667C14.7 2.59052 14.4761 2.36667 14.2 2.36667C13.9239 2.36667 13.7 2.59052 13.7 2.86667V4.76132C12.5718 2.81196 10.4562 1.5 8.03379 1.5C4.42784 1.5 1.5 4.40741 1.5 8C1.5 11.5926 4.42784 14.5 8.03379 14.5C11.3074 14.5 14.0208 12.1042 14.4944 8.97482C14.5357 8.70178 14.3478 8.44695 14.0748 8.40563C13.8018 8.36431 13.5469 8.55215 13.5056 8.82518C13.1055 11.469 10.8096 13.5 8.03379 13.5C4.97482 13.5 2.5 11.035 2.5 8Z"
      fill="currentColor"
    />
  </SvgIcon>
));
